<template>
  <Loader v-if="loading"/>
  <div v-else-if="resolution" class="resolution__item resolution__opened pb-8">
    <div class="resolution__doc__header">
      <div class="resolution__doc__header__left">
        <span class="resolution__doc__title">{{ resolution.title }}</span>

      </div>
      <div class="resolution__doc__header__right">
        <span class="resolution__doc__status green__light">{{ resolution.statusText }}</span>
      </div>
    </div>
    <div class="resolution__body">
      <div class="mb-4">
        <Deadline :resolution="resolution" @updated="deadline => resolution.deadline = deadline"/>
        <div v-if="resolution.conclusion?.number" class="stack__list">
          <span class="stack__label">{{ $lang.app.CONCLUSION }}:</span>
          <span class="stack__value">
                <span class="mr-4">{{ resolution.conclusion.number }}</span>
                <span class="text-gray-400">{{ resolution.conclusion.docDate ? $moment(resolution.conclusion.docDate).format('DD.MM.YYYY HH:mm') : '' }}</span>
              </span>
        </div>
      </div>
      <ResolutionFeedbacks :resolution="resolution"
                           :user-resolution-role="userResolutionRole"/>
    </div>

    <AgreementRemarksModal :resolution="resolution"/>
    <AddExecutorsModal :resolution="resolution"
                       :user-resolution-role="userResolutionRole"/>
    <ReassignResponsibleModal :resolution="resolution"
                              :user-resolution-role="userResolutionRole"/>
    <RejectInProcessRemarksModal :resolution="resolution" />
    <AnswerReturnModal :resolution="resolution"/>
    <ApproveSignModal :resolution="resolution"/>
    <DirectorApproveSignModal :resolution="resolution"/>
    <AssignCuratorModal :resolution="resolution"/>
    <ReassignCuratorModal :resolution="resolution"
                          :user-resolution-role="userResolutionRole"/>
    <DistributionModal :resolution="resolution"/>
    <AnswerReturnFromParentModal :resolution="resolution"/>
    <SelectAgreedsModal/>
    <RemarkSignModal :resolution="resolution"/>
    <ConclusionSignModal :resolution="resolution"/>
    <PaymentChangeRequestModal/>
    <AddPaymentModal/>
    <EditPaymentModal/>
    <ReturnPaymentModal/>
    <PaymentCalculateTaxesModal/>
    <SignPaymentModal/>
    <AccountantSignPaymentModal/>
    <PaymentOrderAttachModal/>
    <AnswerConfirmModal/>
  </div>
</template>
<script>
import resolutionApi from "../../../../api/employee/resolution"
import ResolutionFeedbacks from "../../../../components/employee/application/resolution/ResolutionFeedbacks"
import {getValueByKey as edmTypesGetValueByKey} from "../../../../helpers/constants/edmTypes";
import Deadline from "../../../../components/employee/application/resolution/Deadline";
import AgreementRemarksModal from "../../../../components/employee/application/resolution/modals/AgreementRemarksModal.vue";
import AddExecutorsModal from "../../../../components/employee/application/resolution/modals/AddExecutorsModal.vue";
import ReassignResponsibleModal from "../../../../components/employee/application/resolution/modals/ReassignResponsibleModal.vue";
import AnswerReturnModal from "../../../../components/employee/application/resolution/modals/AnswerReturnModal.vue";
import ApproveSignModal from "../../../../components/employee/application/resolution/modals/ApproveSignModal.vue";
import DirectorApproveSignModal from "../../../../components/employee/application/resolution/modals/DirectorApproveSignModal.vue";
import AssignCuratorModal from "../../../../components/employee/application/resolution/modals/AssignCuratorModal.vue";
import ReassignCuratorModal from "../../../../components/employee/application/resolution/modals/ReassignCuratorModal.vue";
import DistributionModal from "../../../../components/employee/application/resolution/modals/DistributionModal.vue";
import AnswerReturnFromParentModal from "../../../../components/employee/application/resolution/modals/AnswerReturnFromParentModal.vue";
import PaymentChangeRequestModal from "../../../../components/employee/application/resolution/payment/PaymentChangeRequestModal.vue";
import AddPaymentModal from "../../../../components/employee/application/resolution/payment/AddPaymentModal.vue";
import EditPaymentModal from "../../../../components/employee/application/resolution/payment/EditPaymentModal.vue";
import SelectAgreedsModal from "../../../../components/employee/application/resolution/modals/SelectAgreedsModal.vue";
import RemarkSignModal from "../../../../components/employee/application/resolution/modals/RemarkSignModal.vue";
import {getLabelRefByValue as paymentStatusesGetLabelByValue} from "../../../../helpers/constants/paymentStatuses";
import ConclusionSignModal from "../../../../components/employee/application/resolution/modals/ConclusionSignModal.vue";
import ReturnPaymentModal from "../../../../components/employee/application/resolution/payment/ReturnPaymentModal.vue";
import PaymentCalculateTaxesModal from "../../../../components/employee/application/resolution/payment/PaymentCalculateTaxesModal.vue";
import SignPaymentModal from "../../../../components/employee/application/resolution/payment/SignPaymentModal.vue";
import AccountantSignPaymentModal from "../../../../components/employee/application/resolution/payment/AccountantSignPaymentModal.vue";
import PaymentOrderAttachModal from "../../../../components/employee/application/resolution/payment/PaymentOrderAttachModal.vue";
import AnswerConfirmModal from "../../../../components/employee/application/resolution/modals/AnswerConfirmModal.vue";
import RejectInProcessRemarksModal
  from "@/components/employee/application/resolution/modals/RejectInProcessRemarksModal.vue";

export default {
  components: {
    RejectInProcessRemarksModal,
    ResolutionFeedbacks,
    Deadline,
    AgreementRemarksModal,
    AddExecutorsModal,
    ReassignResponsibleModal,
    AnswerReturnModal,
    ApproveSignModal,
    DirectorApproveSignModal,
    AssignCuratorModal,
    ReassignCuratorModal,
    DistributionModal,
    AnswerReturnFromParentModal,
    PaymentChangeRequestModal,
    AddPaymentModal,
    EditPaymentModal,
    SelectAgreedsModal,
    RemarkSignModal,
    ConclusionSignModal,
    ReturnPaymentModal,
    PaymentCalculateTaxesModal,
    SignPaymentModal,
    AccountantSignPaymentModal,
    PaymentOrderAttachModal,
    AnswerConfirmModal,
  },
  data() {
    return {
      showModal: false,

      loading: false,
      resolution: null,
      userResolutionRole: null,
    }
  },
  watch: {
    '$route'(value) {
      if(value.name === 'EmployeeApplicationResolution') {
        this.fetchResolution()
      }
    }
  },
  created() {
    this.fetchResolution()
  },
  beforeMount() {
    this.$emitter.on('refresh-resolution', (payload) => {
      if(!payload) {
        this.fetchResolution()
      } else {
        this.fetchResolution(payload.reload)
      }
    })
  },
  beforeUnmount() {
    this.$emitter.off('refresh-resolution')
  },
  methods: {
    paymentStatusesGetLabelByValue,
    fetchResolution(reload = true) {
      if(reload) {
        this.loading = true
      }
      resolutionApi.getResolution(this.$route.params.resolutionId)
          .then(res => {
            this.resolution = res.data
            this.setUserResolutionRole()
          }).finally(() => {
        this.loading = false
      })
    },
    setUserResolutionRole() {
      if(this.resolution.curator?.id === this.$store.getters.getCurrentUser.employment?.id) {
        this.userResolutionRole = 'ROLE_CURATOR'
      } else if (this.$store.getters.getCurrentUser.employment?.position?.edmType === edmTypesGetValueByKey('HEAD_OF_DEPARTMENT')) {
        this.userResolutionRole = 'ROLE_HEAD_OF_DEPARTMENT'
      } else {
        this.userResolutionRole = this.$store.getters.getCurrentUserRole
      }
    },
  }
}
</script>
